import { cn } from "@/lib/utils";

export const Placeholder = ({ label, note, ratio = "16 / 9", testid, className }) => (
  <figure
    data-testid={testid}
    className={cn("hatch relative m-0 min-h-[200px] w-full min-w-0 overflow-hidden border border-dashed border-o-strong bg-o-surface", className)}
    style={{ aspectRatio: ratio }}
  >
    <svg aria-hidden className="absolute inset-0 h-full w-full text-o-line" viewBox="0 0 100 100" preserveAspectRatio="none">
      <line x1="0" y1="0" x2="100" y2="100" stroke="currentColor" vectorEffect="non-scaling-stroke" />
      <line x1="100" y1="0" x2="0" y2="100" stroke="currentColor" vectorEffect="non-scaling-stroke" />
      <rect x="10" y="10" width="80" height="80" fill="none" stroke="currentColor" vectorEffect="non-scaling-stroke" />
    </svg>
    <figcaption className="absolute inset-0 flex flex-col justify-between p-4 sm:p-5">
      <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-o-dim">Image placeholder · Phase 2</span>
      <span className="max-w-[30ch] self-start border border-o-line bg-o-bg px-3 py-2">
        <span className="block font-display text-[15px] font-bold leading-tight text-o-text">{label}</span>
        {note && <span className="mt-1 block text-xs text-o-dim">{note}</span>}
      </span>
      <span className="self-end font-mono text-[10px] tracking-[0.18em] text-o-dim">{ratio.replace(/\s/g, "")}</span>
    </figcaption>
  </figure>
);
